var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2PicAdvanced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.4C0 19.1598 0 18.0397 0.435974 17.184C0.819467 16.4314 1.43139 15.8195 2.18404 15.436C3.03969 15 4.15979 15 6.4 15H13.849C14.8274 15 15.3166 15 15.7769 15.1105C16.1851 15.2085 16.5753 15.3701 16.9331 15.5894C17.3368 15.8368 17.6827 16.1827 18.3745 16.8745L19.1255 17.6255C19.8173 18.3173 20.1632 18.6632 20.5669 18.9106C20.9248 19.1299 21.3149 19.2915 21.7231 19.3895C22.1834 19.5 22.6726 19.5 23.651 19.5H32.6C34.8402 19.5 35.9603 19.5 36.816 19.936C37.5686 20.3195 38.1805 20.9314 38.564 21.684C39 22.5397 39 23.6598 39 25.9V40.1C39 42.3402 39 43.4603 38.564 44.316C38.1805 45.0686 37.5686 45.6805 36.816 46.064C35.9603 46.5 34.8402 46.5 32.6 46.5H6.4C4.15979 46.5 3.03969 46.5 2.18404 46.064C1.43139 45.6805 0.819467 45.0686 0.435974 44.316C0 43.4603 0 42.3402 0 40.1V21.4Z",
    fill: "#E6B100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1406_60838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50003 22.6C4.50003 22.0399 4.50003 21.7599 4.60902 21.546C4.7049 21.3578 4.85788 21.2049 5.04604 21.109C5.25995 21 5.53998 21 6.10003 21H38.9C39.4601 21 39.7401 21 39.954 21.109C40.1422 21.2049 40.2952 21.3578 40.391 21.546C40.5 21.7599 40.5 22.0399 40.5 22.6V44.9C40.5 45.4601 40.5 45.7401 40.391 45.954C40.2952 46.1422 40.1422 46.2951 39.954 46.391C39.7401 46.5 39.4601 46.5 38.9 46.5H6.10003C5.53998 46.5 5.25995 46.5 5.04604 46.391C4.85788 46.2951 4.7049 46.1422 4.60902 45.954C4.50003 45.7401 4.50003 45.4601 4.50003 44.9V22.6Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1406_60838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 28.9C3 26.6598 3 25.5397 3.43597 24.684C3.81947 23.9314 4.43139 23.3195 5.18404 22.936C6.03969 22.5 7.15979 22.5 9.4 22.5H35.6C37.8402 22.5 38.9603 22.5 39.816 22.936C40.5686 23.3195 41.1805 23.9314 41.564 24.684C42 25.5397 42 26.6598 42 28.9V41.6C42 43.8402 42 44.9603 41.564 45.816C41.1805 46.5686 40.5686 47.1805 39.816 47.564C38.9603 48 37.8402 48 35.6 48H9.4C7.15979 48 6.03969 48 5.18404 47.564C4.43139 47.1805 3.81947 46.5686 3.43597 45.816C3 44.9603 3 43.8402 3 41.6V28.9Z",
    fill: "#F9C206"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1406_60838",
    x: 0.500031,
    y: 17,
    width: 44,
    height: 33.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1406_60838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1406_60838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1406_60838",
    x: -1,
    y: 18.5,
    width: 47,
    height: 33.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1406_60838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1406_60838",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2PicAdvanced);
export default __webpack_public_path__ + "static/media/2pic_advanced.692250e7.svg";
export { ForwardRef as ReactComponent };